import { useState } from 'react';
import { env } from '@shared/config/env';
import type { LlmModel } from './api';

/** Цвета монограмм разработчиков — как в макете. */
const MONO: Record<string, { bg: string; fg: string }> = {
  anthropic: { bg: '#F3E8DF', fg: '#7A3E1D' },
  openai: { bg: '#E5E7EB', fg: '#1F2937' },
  deepseek: { bg: '#E3ECFB', fg: '#1D4FA8' },
  yandex: { bg: '#FCE7D6', fg: '#9A3B00' },
  google: { bg: '#E4F2E8', fg: '#1F6B3A' },
  moonshotai: { bg: '#EDE7FA', fg: '#5B32B4' },
  qwen: { bg: '#EDE7FA', fg: '#5B32B4' },
};

export function vendorMono(code: string | null) {
  return MONO[code ?? ''] ?? { bg: '#F3F4F6', fg: '#374151' };
}

export function vendorLetter(m: Pick<LlmModel, 'vendor_code' | 'vendor_title' | 'title'>) {
  if (m.vendor_code === 'yandex') return 'Я';
  return (m.vendor_title || m.title || '?').trim()[0]?.toUpperCase() ?? '?';
}

interface Props {
  model: Pick<LlmModel, 'vendor_code' | 'vendor_title' | 'title' | 'logo_url'>;
  size?: number;
}

/** Логотип разработчика (с сервера), иначе монограмма. */
export function ModelAvatar({ model, size = 36 }: Props) {
  const [broken, setBroken] = useState(false);
  const c = vendorMono(model.vendor_code);
  const radius = size >= 30 ? 9 : 5;
  if (model.logo_url && !broken) {
    return (
      <img
        src={`${env.API_BASE_URL}${model.logo_url}`}
        alt=""
        width={size}
        height={size}
        onError={() => setBroken(true)}
        style={{
          borderRadius: radius,
          flex: 'none',
          objectFit: 'contain',
          background: '#fff',
          border: '1px solid #F3F4F6',
        }}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        flex: 'none',
        borderRadius: radius,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: size >= 30 ? 14 : 11,
        background: c.bg,
        color: c.fg,
      }}
    >
      {vendorLetter(model)}
    </span>
  );
}
